export default function () {
  if (document.getElementById('adaf-app')) {
    import(
      /* webpackChunkName: "adaf-vue-app" */ '../_03_organisms/adaf/main'
    );
  }
}
